import { connect } from 'react-redux'
import PagedSearch from 'pages/search/PagedSearch'
import { setSearchResponse, setSearchResultsLoaded } from 'redux/actions'

const mapDispatchToProps = (dispatch) => ({
  setSearchResponse: (response) => dispatch(setSearchResponse(response)),
  setSearchResultsLoaded: (isLoaded) =>
    dispatch(setSearchResultsLoaded(isLoaded))
})

export default connect(null, mapDispatchToProps)(PagedSearch)
